import React, {FC} from 'react';
import styled from 'styled-components';

import {VisualSizesEnum} from '../../../../libs/shared/ui/src/styles/commonStyles';
import {AccountModel} from '../../../models/api/accountModel';
import {AccountAvatar} from '../../common/avatars/accountAvatar';
import {AvatarEditor} from '../../common/avatars/avatarEditor';
import {
  AccountDetailsEditActionsEnum,
  AccountDetailsEditAttributesEnum,
  buildAccountDetailsEditPayload,
} from '../tracking/accountDetailsTrackingHelpers';
import {useAccountDetailsContext} from './accountDetailsContext';
import {AccountDetailsHeaderDomains} from './accountDetailsHeaderDomains';
import {AccountDetailsHeaderNameContainer} from './accountDetailsHeaderNameContainer';

/*
 * Types.
 */

interface AccountDetailsHeaderProps {
  account: AccountModel;
  shouldDisableActions?: boolean;
  updateAccountAvatarAsync: (account: AccountModel, file: File) => Promise<void>;
}

/*
 * Styles.
 */

const AccountDetailsHeaderDiv = styled.div`
  display: flex;
  padding: 20px 16px;
`;

const AccountDetailsDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 4px;
  min-width: 0;
  width: 100%;
`;

/*
 * Component.
 */

export const AccountDetailsHeader: FC<AccountDetailsHeaderProps> = (props) => {
  const {account, shouldDisableActions, updateAccountAvatarAsync} = props;
  const {panelId, onTrackEvent} = useAccountDetailsContext();

  return (
    <AccountDetailsHeaderDiv>
      <AvatarEditor
        isDisabled={shouldDisableActions}
        avatar={<AccountAvatar account={account} size={VisualSizesEnum.EXTRA_LARGE} avatarIconSize={22} />}
        onFileChange={async (file: File) => {
          await updateAccountAvatarAsync(account, file);
          onTrackEvent(
            buildAccountDetailsEditPayload(
              account.id,
              account.avatarUrl ? AccountDetailsEditActionsEnum.EDIT : AccountDetailsEditActionsEnum.ADD,
              AccountDetailsEditAttributesEnum.AVATAR,
            ),
          );
        }}
      />
      <AccountDetailsDiv>
        <AccountDetailsHeaderNameContainer
          account={account}
          panelId={panelId}
          shouldDisableActions={shouldDisableActions}
        />
        <AccountDetailsHeaderDomains account={account} shouldDisableActions={shouldDisableActions} />
      </AccountDetailsDiv>
    </AccountDetailsHeaderDiv>
  );
};
